import { isArray } from 'lodash';

export const eventSubscription = ({
  target = global,
  callbacksBus,
  postfix = 'EventListener',
  actionAdd = 'add',
  actionRemove = 'remove',
}) => {
  const listenerLogic = (action) => {
    callbacksBus.forEach(({ event, callback, options, target: localTarget }) => {
      if (!event) return;

      const eventsArray = Array.isArray(event) ? event : [event];

      eventsArray.forEach((event) => {
        const totalTarget = localTarget ?? target;

        const targetArray = isArray(totalTarget) ? totalTarget : [totalTarget];

        targetArray.forEach((target) => {
          target?.[`${action}${postfix}`]?.(event, callback, options);
        });
      });
    });
  };

  listenerLogic(actionAdd);

  return () => listenerLogic(actionRemove);
};
